import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';

const CONSENT_KEY = 'ecobike_cookie_consent';
const CONSENT_VALUE_ACCEPTED = 'accepted-v1';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let stored = null;
    try {
      stored = window.localStorage.getItem(CONSENT_KEY);
    } catch {
      // localStorage may be disabled
    }
    if (!stored) {
      // Slight delay so it doesn't fight the hero entrance animation.
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    try {
      window.localStorage.setItem(CONSENT_KEY, CONSENT_VALUE_ACCEPTED);
    } catch { /* ignore */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Cookie notice"
      className="fixed inset-x-3 bottom-3 sm:inset-x-auto sm:left-4 sm:right-4 sm:bottom-4 md:max-w-2xl md:left-1/2 md:-translate-x-1/2 z-[60] bg-[var(--brand-forest-deep)] text-[var(--brand-parchment)] border border-[var(--brand-gold)]/30 shadow-2xl"
    >
      <div className="grain absolute inset-0 opacity-40 pointer-events-none" />
      <div className="relative px-5 py-4 sm:px-6 sm:py-5 flex flex-col md:flex-row md:items-center gap-4">
        <Cookie size={22} className="text-[var(--brand-gold)] shrink-0" strokeWidth={1.6} />
        <div className="text-sm leading-relaxed flex-1">
          We use one essential cookie to remember this choice. No tracking, no
          advertising cookies.{' '}
          <Link
            to="/cookies"
            data-testid="cookie-banner-policy-link"
            className="link-expand underline-offset-2 text-[var(--brand-gold)]"
          >
            Read our cookies policy
          </Link>
          .
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button
            data-testid="cookie-banner-accept"
            onClick={accept}
            className="btn-gold px-4 py-2 text-xs font-semibold tracking-wide rounded-none"
          >
            Understood
          </button>
          <button
            data-testid="cookie-banner-dismiss"
            onClick={accept}
            aria-label="Dismiss cookie notice"
            className="w-9 h-9 grid place-items-center border border-[var(--brand-parchment)]/30 hover:border-[var(--brand-gold)] hover:text-[var(--brand-gold)] transition-colors"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
